//For Production server//
export const environment = {
  production: true,
  baseUrl  : 'https://cmis3api.anudip.org/',
  imgBaseUrl: 'https://www.storage.anudip.org/home/storage/',
  apiUrl   : 'https://cmis4api.anudip.org/public/',
  gloginUrl: 'https://cmis4api.anudip.org/api/login/google/',
};

//For Stage server//
// export const environment = {
//   production: true,
//   baseUrl  : 'http://109.235.71.145/cmisv3-api-temp/public/',
//   imgBaseUrl: 'http://109.235.71.145/cmisv3-api-temp/public/',
//   apiUrl   : 'http://109.235.71.145/cmisv3-api-temp/public/',
//   gloginUrl: 'http://cmis3api.anudip.org/api/login/google/',
// };